/* Adds presentation only. The order-limits app retains cart/checkout enforcement. */
(() => {
  'use strict';
  const initialized = new WeakSet();
  function initPanel(panel) {
    if (initialized.has(panel)) return;
    const form = panel.closest('form');
    const section = panel.closest('[data-section-type="product"]');
    const json = panel.querySelector('[data-fabric-variants]');
    if (!form || !json) return;
    let variants;
    try { variants = JSON.parse(json.textContent); } catch (_) { return; }
    initialized.add(panel);
    const quantity = form.querySelector('[name="quantity"]');
    const stock = panel.querySelector('[data-fabric-stock]');
    const minimum = panel.querySelector('[data-fabric-minimum]');
    const unit = panel.dataset.unit || 'yard';
    let unavailableSelection = false;
    let selectedId = panel.dataset.variantId;
    function setText(element, value) {
      if (element && element.textContent !== value) element.textContent = value;
    }
    function update() {
      const selector = form.querySelector('[name="id"]');
      const id = selector ? selector.value : selectedId;
      const variant = unavailableSelection ? null : variants.find(item => String(item.id) === String(id));
      const appMinimum = quantity ? Number(quantity.min) : 0;
      const displayMinimum = appMinimum > 1 ? appMinimum : Number(panel.dataset.minimum);
      setText(minimum, String(displayMinimum));
      setText(stock, !variant || !variant.available ? 'Currently unavailable' :
        variant.tracked && variant.policy !== 'continue' ? `Available: ${variant.inventory} ${unit}s` : 'Available to order');
    }
    const scheduleUpdate = () => requestAnimationFrame(update);
    form.addEventListener('input', scheduleUpdate);
    form.addEventListener('change', scheduleUpdate);
    form.addEventListener('click', scheduleUpdate); // Impulse's +/- buttons change .value without an input event.
    if (section) section.addEventListener('variantChange', event => {
      unavailableSelection = !event.detail.variant;
      selectedId = event.detail.variant ? event.detail.variant.id : null;
      scheduleUpdate(); // Master variant select updates after the theme's variantChange event.
    });
    if (quantity) new MutationObserver(scheduleUpdate).observe(quantity, {
      attributes: true, attributeFilter: ['value', 'min', 'max', 'step']
    });
    update();
    // Apps may initialize constraints after theme scripts finish.
    window.addEventListener('load', scheduleUpdate, { once: true });
  }
  function init(root) {
    if (root.matches && root.matches('[data-fabric-order]')) initPanel(root);
    if (root.querySelectorAll) root.querySelectorAll('[data-fabric-order]').forEach(initPanel);
  }
  init(document);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) init(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-fabric-sort]')) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });
})();
